module.exports = __webpack_public_path__ + "img/02基本資訊.ef97f61f.jpg";